var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"before:h-52 before:w-full before:absolute before:z-0 before:bg-gradient-to-b before:from-blue before:to-midBlue children:z-10 children:relative"},[_c('img',{staticClass:"w-40 mx-auto py-6",attrs:{"src":require("@/assets/signable.svg"),"alt":"Signable"}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }